export const buildShareUrl = (path: string): string => {
  const base =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : 'https://fgupnxk.cn';
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  } catch {
    return false;
  }
};

export interface ShareTarget {
  key: string;
  label: string;
  icon: string;
  buildUrl: (url: string, title: string) => string;
}

export const shareTargets: ShareTarget[] = [
  {
    key: 'weibo',
    label: '微博',
    icon: 'ri-weibo-fill',
    buildUrl: (url, title) =>
      `https://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
  },
  {
    key: 'twitter',
    label: 'X',
    icon: 'ri-twitter-x-fill',
    buildUrl: (url, title) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
  },
  {
    key: 'facebook',
    label: 'Facebook',
    icon: 'ri-facebook-circle-fill',
    buildUrl: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
];